import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notification-popup__text" }
const _hoisted_2 = { class: "notification-popup__title" }
const _hoisted_3 = ["innerHTML"]

import { onMounted, ref } from "vue";
import NotificationPopupProps from "./notification-popup-props";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'notification-popup',
  props: {
    id: {},
    title: {},
    description: {},
    variant: { default: "icon" },
    imageUrl: { default: "/frontend/web/img/notifications/prize.svg" },
    theme: { default: "light" },
    position: {},
    autoCloseDuration: { default: 10000 }
  },
  emits: ["destroyPopup"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const notification = ref<HTMLElement>(null);
let fadeOutDuration = 0;

const isClosing = ref(false);
const isImageVariant = props.variant === "image";

let touchStartY = 0;
let touchEndY = 0;

const closeNotification = () => {
    isClosing.value = true;

    setTimeout(() => {
        emit("destroyPopup");
    }, fadeOutDuration);
};

const touchStart = (event: TouchEvent) => {
    // prevent scrolling page through element
    event.preventDefault();
    touchStartY = event.changedTouches[0].screenY;
};

const touchEnd = (event: TouchEvent) => {
    touchEndY = event.changedTouches[0].screenY;

    const swipeDistance = Math.abs(touchStartY - touchEndY);

    if (touchEndY < touchStartY && swipeDistance > 10) {
        closeNotification();
    }
};

onMounted(() => {
    // get fadeOutDuration value from css variable
    fadeOutDuration = parseInt(getComputedStyle(notification.value).getPropertyValue("--fade-out-duration"));

    if (props.autoCloseDuration) {
        setTimeout(closeNotification, props.autoCloseDuration);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notification-popup", [
            `notification-popup--${_ctx.theme}`,
            { 'notification-popup--image': isImageVariant },
            { 'notification-popup--fade-out': isClosing.value },
        ]]),
    ref_key: "notification",
    ref: notification,
    onTouchstart: touchStart,
    onTouchend: touchEnd,
    role: "status",
    "aria-live": "polite"
  }, [
    (_ctx.imageUrl)
      ? (_openBlock(), _createBlock(WebpImage, {
          key: 0,
          src: _ctx.imageUrl,
          alt: "",
          "css-class": ['notification-popup__image', { 'notification-popup__image--big': isImageVariant }],
          class: _normalizeClass(["notification-popup__picture", { 'notification-popup__picture--big': isImageVariant }])
        }, null, 8, ["src", "css-class", "class"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "notification-popup__description",
            innerHTML: _ctx.description
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      class: "notification-popup__close",
      onClick: closeNotification,
      "aria-label": "Zavřít notifikaci"
    })
  ], 34))
}
}

})